export function useShopCurrency() {
  const {
    public: { shopRegion },
  } = useRuntimeConfig();

  return shopRegion === "UK" ? "GBP" : "EUR";
}
